module.exports = __webpack_public_path__ + "img/empty.38a101a5.svg";